import * as React from "react";

function TrackingIcon(props) {
  return (
    <svg viewBox="0 0 64 64" width="1em" height="1em" {...props}>
      <path d="M61.707 34.293L49.293 21.879A2.978 2.978 0 0047.171 21H30v2h5v15h2V23h10.171a1 1 0 01.708.293L49.586 25H45a2 2 0 00-2 2v9a2 2 0 002 2h15v8a1 1 0 01-1 1h-2.08a6.991 6.991 0 00-13.84 0H28.92a6.991 6.991 0 00-13.84 0H13a1 1 0 01-1-1v-9h-2v9a3 3 0 003 3h2.08a6.978 6.978 0 002.031 4H2v2h48a7.006 7.006 0 006.92-6H59a3 3 0 003-3V35a1 1 0 00-.293-.707zM17 48a5 5 0 115 5 5.006 5.006 0 01-5-5zm9.889 5a6.978 6.978 0 002.031-4h14.16a6.978 6.978 0 002.031 4zM50 53a5 5 0 115-5 5.006 5.006 0 01-5 5zm-5-17v-9h6.586L60 35.414V36z" />
      <path d="M21 47h2v2h-2zM49 47h2v2h-2zM2 44h5v2H2zM4 40h3v2H4zM5 36h2v2H5zM15 35A13 13 0 102 22a13.015 13.015 0 0013 13zm0-24A11 11 0 114 22a11.013 11.013 0 0111-11z" />
      <path d="M15 31a1 1 0 00.707-.293C16.351 30.063 22 24.29 22 20a7 7 0 00-14 0c0 4.29 5.649 10.063 6.293 10.707A1 1 0 0015 31zm0-16a5.006 5.006 0 015 5c0 2.566-3.147 6.531-5 8.551-1.853-2.02-5-5.985-5-8.551a5.006 5.006 0 015-5z" />
      <path d="M18 20a3 3 0 10-3 3 3 3 0 003-3zm-4 0a1 1 0 111 1 1 1 0 01-1-1zM40 40h4v2h-4z" />
    </svg>
  );
}

const MemoTrackingIcon = React.memo(TrackingIcon);
export default MemoTrackingIcon;
